// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._5yqHR7yNx{}._5yqHR7yNx>*:not(:last-child){margin-right:8px}._2D40hjeex{flex-shrink:1}._39JSSCoZx{}._39JSSCoZx ._5FZcatyQx{margin-left:8px;flex-shrink:9999999}@media screen and (-ms-high-contrast: black-on-white){._5yqHR7yNx:not(._3d11wct6x) ._6NJFxJ09x,._39JSSCoZx:not(._3d11wct6x) ._6NJFxJ09x{color:currentColor}}\n", "",{"version":3,"sources":["webpack://client/shared/dropdown/item.scss"],"names":[],"mappings":"AAAwmB,YAAoD,CAAC,+BAAyB,gBAAgB,CAAC,YAAO,aAAa,CAAC,YAAqB,CAAC,wBAAqB,eAAe,CAAC,mBAAmB,CAAC,sDAAsD,kFAAwD,kBAAkB,CAAC","sourcesContent":[":export{tabletScreen:768px;smallScreen:1100px;mediumScreen:1300px;largeScreen:1500px;azure:#006fc8;cyan:#1FAECE;primaryText:var(--primary-text);secondaryText:var(--secondary-text);chartGridColor:var(--ui-divider);gray10:#dedede;msDarkBlue:#002050;amberLight2:#F7E28B;violetLight2:#CEC0EC;tealLight3:#CFECE8;bannerBlue:var(--banner-blue);spaceXXS:4px;spaceXS:8px;spaceS:16px;spaceM:20px;spaceXM:24px;spaceL:32px;spaceXL:40px;spaceXXL:60px;panelSlideDuration:200ms;panelFadeDuration:100ms;ccBannerHeight:46px;chartCyan:var(--charts-cyan);chartMapBorders:var(--charts-map-border);chartMapBgDefault:var(--charts-map-bg)}.item{composes:ellipsize from '../styles/utils.scss'}.item>*:not(:last-child){margin-right:8px}.title{flex-shrink:1}.inline{composes:item}.inline .description{margin-left:8px;flex-shrink:9999999}@media screen and (-ms-high-contrast: black-on-white){.item:not(.disabled) .text,.inline:not(.disabled) .text{color:currentColor}}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"item": "_5yqHR7yNx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"title": "_2D40hjeex",
	"inline": "_39JSSCoZx _5yqHR7yNx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"description": "_5FZcatyQx",
	"disabled": "_3d11wct6x",
	"text": "_6NJFxJ09x"
};
export default ___CSS_LOADER_EXPORT___;
